var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpchevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2896_1554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21924 5.22755C7.61956 4.72733 8.38044 4.72733 8.78076 5.22755L12.6997 10.1244C13.2236 10.7792 12.7575 11.7493 11.9189 11.7493H4.08109C3.24251 11.7493 2.77636 10.7792 3.30033 10.1244L7.21924 5.22755Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2896_1554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpchevron);
export default __webpack_public_path__ + "static/media/upchevron.0cda2d5ba505cba4cf2a65fafe7c1cdb.svg";
export { ForwardRef as ReactComponent };